import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from "@angular/fire/auth";
// import { Observable } from 'rxjs';
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
    private router : Router,
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    ){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      this.afAuth.authState.subscribe(user => {
        if (!user){
          localStorage.removeItem ('uid');
          this.router.navigateByUrl('/login');
        }
      })
        if(!localStorage.getItem('uid')){
            localStorage.removeItem ('uid');
            this.router.navigateByUrl('/login');
            return false;
        }
    return true;
  }
}
